import { render, staticRenderFns } from "./KidAgeSelector.vue?vue&type=template&id=61168196"
import script from "./KidAgeSelector.vue?vue&type=script&lang=js"
export * from "./KidAgeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports